module.exports = __webpack_public_path__ + "static/img/img_basket_3d.7171318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_basket_3d.png
// module id = hryx
// module chunks = 1